import { DatePipe } from '@angular/common';
import { Component, Injector, Input } from '@angular/core';
import CheckboxComponent from '@app/shared/common/checkbox/checkbox.component';
import DateTimeService from '@app/shared/common/timing/date-time.service';
import SvgIconComponent from '@app/shared/svg-icon/svg-icon.component';
import AppComponentBase from '@shared/common/app-component-base';
import WindowWidthService from '@shared/utils/window-width.service';
@Component({
    selector: 'app-task',
    templateUrl: './task.component.html',
    styleUrls: ['./task.component.less'],
    imports: [
        DatePipe,
        CheckboxComponent,
        SvgIconComponent,
    ],
})
class TaskComponent extends AppComponentBase {
    @Input() text = '';

    @Input() date?: Date | string;

    @Input() name = '';

    @Input() avatar = 'https://picsum.photos/32/32';

    @Input() checked = false;

    @Input() isDisabled = false;

    constructor(
        injector: Injector,
        private windowWidthService: WindowWidthService,
        private _dateTimeService: DateTimeService,
    ) {
        super(injector);
    }

    get isMobile() {
        const { isMobile, isSmallMobile, isTablet, isSmallTablet } = this.windowWidthService.getWindowWidthState();
        return isMobile || isSmallMobile || isTablet || isSmallTablet;
    }

    isToday(dateString: string): boolean {
        return this._dateTimeService.isToday(dateString);
    }

}

export default TaskComponent;
